import Image from 'next/image';

const ResponsiveImage = props => {
  const {style, ...rest} = props;

  return (
    <div style={{position: 'relative', height: 'min(400px, 50vh)', ...style}}>
      <Image alt={props.alt} style={{width: '100%', objectFit: 'contain', backgroundColor: 'transparent'}} sizes='(max-width: 768) 50vh, (max-width: 1200px) 50vw, 33vw' fill {...rest} />
    </div>
  );
};

export function useMDXComponents(components) {
  return {
    ...components,
    img: ResponsiveImage,
    Image: ResponsiveImage
  };
}
